module.exports = __webpack_public_path__ + "img/City-Marriott-Hotel-Kochi.2acdba9b.jpg";